import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {

  registerForm = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required]]
  });

  constructor(private fb: FormBuilder, private apiService: ApiService, private storage: StorageService) { }

  register() {
    if (this.registerForm.valid) {
      const details = {
        'name': this.registerForm.value.name,
        'email': this.registerForm.value.email,
        'phone': this.registerForm.value.phone
      };
      this.apiService.register(details).then((data: any) => {
        if (data["success"]) {
          this.apiService.isRegisterOtp.next(true);
          this.storage.set('user_data', JSON.stringify(data["data"]));
          this.storage.set('user_id', data["data"].id);
        }
      });
    }
  }

  goToLogin() {
    this.apiService.isLogin.next(true);
  }

}
